import { Builder } from '@builder.io/sdk';

Builder.register('insertMenu', {
	name: 'Layouts',
	priority: 1,
	items: [{ name: 'Layout' }, { name: 'LayoutSQV2' }],
});

Builder.register('insertMenu', {
	name: 'Page Sections',
	priority: 2,
	items: [
		{ name: 'Header' },
		{ name: 'Hero' },
		{ name: 'Form' },
		{ name: 'SingleForm' },
		{ name: 'LogoBar' },
		{ name: 'SecondaryHero' },
		{ name: 'CopyAndImage' },
		{ name: 'ThreeColumn' },
		{ name: 'Settlements' },
		{ name: 'Accordion' },
		{ name: 'CtaSection' },
		{ name: 'IconList' },
		{ name: 'HeaderV2' },
		{ name: 'TestimonialCarousel' },
	],
});

Builder.register('insertMenu', {
	name: 'Child Blocks',
	priority: 2,
	items: [{ name: 'Button' }],
});
